import { useLocation } from "react-router-dom";

import { names } from "./names";
import styles from "./PageName.module.scss";

import { Title } from "../../../Title";


export const PageName = () => {
  const { pathname } = useLocation();

  const data = getPageName(pathname);

  return (
    <div className={styles.root}>
      <span className={styles.icon}>{data.icon}</span>
      <Title tagName="h4" className={styles.title}>{data.title}</Title>
      {data.addon && <span className={styles.addon}>{data.addon}</span>}
    </div>
  );
};

export const getPageName = (pathname: string): any => {
  // eslint-disable-next-line
  const path = pathname.match(/^\/[^\/]+/)?.[0] || pathname;

  const match = names[path];
  
  if (!match) {
    return {
      title: "Page Not Found",
      icon: null,
      addon: null
    };
  }

  return match;
}
